import type { MatchStatus } from './bracketTypes';
import type { CompetitionStatus } from './types';

/** Dyscypliny obslugiwane przez platforme. Kolory pochodza z brandbooka. */
export type Discipline = 'tennis' | 'padel' | 'squash' | 'pickleball';

export const DISCIPLINE_LABELS: Record<Discipline, string> = {
  tennis: 'Tenis',
  padel: 'Padel',
  squash: 'Squash',
  pickleball: 'Pickleball',
};

/** Etykiety statusow meczu — wspoldzielone przez legendy, karty i badge'e. */
export const MATCH_STATUS_LABELS: Record<MatchStatus, string> = {
  finished: 'Zakończony',
  live: 'W trakcie',
  suspended: 'Przerwany',
  scheduled: 'Zaplanowany',
  walkover: 'Walkower',
  retired: 'Krecz',
};

/** Etykiety statusow rozgrywki z API (`CompetitionStatus`). */
export const COMPETITION_STATUS_LABELS: Record<string, string> = {
  DRAFT: 'Szkic',
  AWAITING_PAYMENT: 'Oczekuje na opłatę',
  REGISTRATION_OPEN: 'Zapisy otwarte',
  REGISTRATION_CLOSED: 'Zapisy zamknięte',
  IN_PROGRESS: 'W trakcie',
  COMPLETED: 'Zakończony',
  CANCELLED: 'Anulowany',
};

/**
 * Ton etykiety statusu rozgrywki — wspolny dla listy turniejow i okna podgladu,
 * zeby ten sam status nie mial dwoch roznych kolorow w dwoch miejscach.
 */
export const COMPETITION_STATUS_TONE: Record<
  CompetitionStatus,
  'brand' | 'success' | 'info' | 'warning' | 'danger' | 'neutral'
> = {
  DRAFT: 'warning',
  AWAITING_PAYMENT: 'warning',
  REGISTRATION_OPEN: 'info',
  REGISTRATION_CLOSED: 'info',
  IN_PROGRESS: 'brand',
  COMPLETED: 'success',
  CANCELLED: 'danger',
};

/** Etykiety kategorii turnieju z API (`CompetitionCategory`). */
export const COMPETITION_CATEGORY_LABELS: Record<string, string> = {
  OPEN: 'Open',
  PRO: 'Pro',
  PROAM: 'Pro-Am',
  AMATEUR: 'Amator',
  JUNIOR: 'Junior',
  KIDS: 'Dzieci',
};

/** Etykiety typu meczu z API (`MatchType`). */
export const MATCH_TYPE_LABELS: Record<string, string> = {
  SINGLES: 'Singiel',
  DOUBLES: 'Debel',
  MIXT: 'Mikst',
};
